
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  ReloadOutlined,
  HomeOutlined
} from '@ant-design/icons-vue';
import EleProSidebarItem from '../../ele-pro-sidebar-item';
import EleProSidebarMenus from '../../ele-pro-sidebar-menus';

export default {
  name: 'EleProHeader',
  components: {
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    ReloadOutlined,
    HomeOutlined,
    EleProSidebarItem,
    EleProSidebarMenus
  },
  emits: [
    'logo-click',
    'reload-page',
    'toggle-collapse'
  ],
  props: {
    // 项目名
    projectName: String,
    // 面包屑导航数据
    levels: Array,
    // 顶栏菜单数据
    menus: Array,
    // 顶栏菜单选中
    active: Array,
    // 顶栏风格
    headStyle: String,
    // 是否折叠侧栏
    collapse: Boolean,
    // 是否显示左边功能区
    showLeftTool: Boolean,
    // 是否显示折叠按钮
    showCollapse: Boolean,
    // 是否显示刷新按钮
    showRefresh: Boolean,
    // 是否显示面包屑导航
    showBreadcrumb: Boolean,
    // 面包屑导航分隔符
    breadcrumbSeparator: String,
    // 是否使用递归渲染顶栏菜单
    useDeep: Boolean
  },
  computed: {
    // 是否是主色顶栏
    isPrimary() {
      return this.headStyle === 'primary';
    },
    // 顶栏菜单主题
    theme() {
      return this.isPrimary ? 'light' : this.headStyle;
    }
  },
  methods: {
    /* 折叠展开侧栏 */
    toggleCollapse() {
      this.$emit('toggle-collapse');
    },
    /* 刷新页面 */
    reloadPage() {
      this.$emit('reload-page');
    },
    /* logo点击事件 */
    onLogoClick() {
      this.$emit('logo-click');
    }
  }
}
